import { brl, fmtTime } from "@/lib/api";
import { activeItems } from "@/lib/mobile";
import { cardCls, Chip } from "@/components/mobile/parts";
import { cn } from "@/lib/utils";

export function ComandaCard({ c, onClick, showWaiter }) {
  const n = activeItems(c).length;
  return (
    <button onClick={onClick} className={cn(cardCls, "flex w-full items-center gap-4 p-4 text-left transition-transform active:scale-[0.99]")} data-testid={`m-comanda-card-${c.number}`}>
      <span className={cn("grid h-14 w-14 shrink-0 place-items-center rounded-2xl font-display text-xl font-bold text-white", c.offline ? "bg-amber-500" : "bg-[#1565c0]")}>{c.number}</span>
      <div className="min-w-0 flex-1">
        <p className="truncate font-semibold">{c.customer_name || "Sem nome"}</p>
        <p className="text-xs text-slate-500">{c.table_number ? `Mesa ${c.table_number}` : "Sem mesa"} · {n} item(ns){c.opened_at ? ` · ${fmtTime(c.opened_at)}` : ""}</p>
        {showWaiter && <p className="text-xs font-medium text-[#1565c0]" data-testid={`m-comanda-waiter-${c.number}`}>Garçom: {c.opened_by || "—"}</p>}
        {c.offline && <div className="mt-1"><Chip tone={c.error ? "red" : "amber"}>{c.error ? "Erro ao criar" : "Guardada no celular"}</Chip></div>}
      </div>
      <span className="font-mono font-bold text-[#0d47a1]" data-testid={`m-comanda-card-total-${c.number}`}>{brl(c.total)}</span>
    </button>
  );
}
